/** Relative **`/api/v1/auth/me`** (**GET**, session cookie). */
export const AUTH_ME_PATH = "/api/v1/auth/me";

/** Relative **`/api/v1/auth/logout`** (**POST**, clears session cookie). */
export const AUTH_LOGOUT_PATH = "/api/v1/auth/logout";

/**
 * Returns organizer session JSON when the browser sends a valid session cookie.
 *
 * @param init - Optional fetch init (`signal` for `AbortController`).
 */
export function fetchSessionMe(init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }
  return fetch(AUTH_ME_PATH, {
    ...init,
    method: "GET",
    credentials: "same-origin",
    headers,
  });
}

/**
 * Ends the organizer server-side session and clears **`quiz_organizer_sid`** (or configured name).
 *
 * @param init - Optional fetch init (`signal` for `AbortController`).
 */
export function postLogout(init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }
  return fetch(AUTH_LOGOUT_PATH, {
    ...init,
    method: "POST",
    credentials: "same-origin",
    headers,
  });
}
